const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Sodelujočim se kešbek provizije knjižijo na podlagi posredovanih podatkov o prihodkih.",
};

export default {
  messages,
};
